import { fn, IInfOperation } from '@common/utils';
import resolveToError = fn.resolveToError;
import UISafe = fn.UISafe;
import { IFDRW_Job_Queue_Entry_List, Status } from '@common/rwf';
import { INavUrlInfoEx, BuildNavUrl } from '../nav';
import { INavItemsGridOptions } from '../navkendo';
import { GridColumn, NavClientService, NavPageItem, NavPageItems, ResolveNavUrl, INavUrlInfo } from '../navdata';
import { CompatibilityService } from '@services/compatibilityservice';
import { IKWFRoute } from '../KWFMain';
import { DialogService } from '@services/dialogservice';

export class KWFJobQueueController {
    static Route = <IKWFRoute>{
        DescriptionFormula: "vm.Info",
        template: require('./jobQueues.fragment.html'),
        controller: KWFJobQueueController,
        controllerAs: "vm",
        name: "Aufgabenwarteschlangenposten",
        AllowChangeCompany: false
    };
    static $inject = ["CompatibilityService", "NavClient", "DialogService"];
    constructor(
        private $c: CompatibilityService,
        navService: NavClientService,
        private DialogService: DialogService
    ) {
        navService.GetAvailableUrls(true).then(urls => {
            this.Urls = urls;
            const normalize = (item: INavUrlInfo) => item.BaseUrl + "/ws/" + item.QueryString;
            this.BaseUrls = fn.distinct(urls.map(normalize));
            var info = this.BaseUrls.map(url => {
                var getCompany = <string | PromiseLike<string>>urls.filter(item => normalize(item) == url)[0].Mandant;
                if (!getCompany)
                    getCompany = navService.GetCompanies(url).then(c => c[0]);

                return $c.when(getCompany).then(company => {
                    var urlInfo = ResolveNavUrl(url);                    
                    var fullUrl = urlInfo.BaseUrl +  "/ws/" + company + urlInfo.QueryString;

                    let loadData = () => navService.LoadPageItems<IFDRW_Job_Queue_Entry_List>({ PageName: "FDRW_Job_Queue_Entry_List", PageCount: 0, Constraints: [] }, fullUrl);
                    var init = loadData();
                    const resetRefresh = () => this.CurrRefresh = undefined;
                    this.CurrRefresh = init.then(resetRefresh, resetRefresh);
                    this.RefreshAction.Enabled = false;
                    return init.then(entries => {
                        var metaData = entries.ClientInfo.MetaData,
                            pColumns = metaData.Properties.filter(p => p.Invisible !== true).map(c => metaData.GetColumn(c)).filter(fn.isSet);
                        pColumns.forEach(p => p.infEditable = false);
                        pColumns.splice(0, 0, <GridColumn>{
                            command: [{
                                attr: { title: "in Newsystem öffnen" }, name: "x", text: "", className: "idms_DataGridButton",
                                template: "<a style='padding-right:15px' class='k-grid-editRwfDoc'><span ng-click='vm.OpenInNav(dataItem)' class='idms_Icon idms_Icon_Zoom idms_HoverIcon' title='in Newsystem öffnen'></span></a>"
                            }, {
                                attr: { title: "Neu starten" }, name: "", text: "y", className: "idms_DataGridButton",
                                template: `<a style='padding-right:10px'><span ng-show='dataItem' ng-click='vm.ExecuteMethod(dataItem, "Restart", "${url}")' class='idms_Icon idms_Icon_Start idms_HoverIcon' title='Neu starten'></span></a>`
                            }, {
                                attr: { title: "Auf 'Abwarten' setzen" }, name: "z", text: "", className: "idms_DataGridButton",
                                template: `<a style='padding-right:10px'><span ng-show='dataItem' ng-click='vm.ExecuteMethod(dataItem, "SetOnHold", "${url}")' class='idms_Icon idms_Icon_Pause idms_HoverIcon' title='Auf "Abwarten" setzen'></span></a>`
                            }, {
                                attr: { title: "Status auf 'Bereit' festlegen" }, name: "z", text: "", className: "idms_DataGridButton",
                                template: `<a><span ng-show='dataItem' ng-click='vm.ExecuteMethod(dataItem, "SetReady", "${url}")' class='idms_Icon idms_Icon_OK idms_HoverIcon' title='Status auf "Bereit" festlegen'></span></a>`
                            }],
                            title: "Aktionen",
                            width: "135px"
                        });

                        return this.Data[url] = {
                            Data: entries,
                            GridOptions: <INavItemsGridOptions>{
                                baseOptions: {
                                    columns: pColumns,
                                    reorderable: true,
                                    sortable: true,
                                    columnMenu: { filterable: false },
                                    resizable: true,
                                    selectable: 'row',
                                    groupable: true,
                                    dblClick: (item) => this.OpenInNav(<any>item.item)
                                },
                                Readonly: true,
                                Source: entries
                            },
                            Refresh: () => entries.RevertItem(true)
                        };
                    });
                });
            });

            const enableRefresh = () => this.RefreshAction.Enabled = true;
            $c.all(info).then((rInfo) => this.refreshInfo()
                , err => {
                    this.Info = resolveToError(err);
                }).then(enableRefresh, enableRefresh);
        });
    }

    OpenInNav(dataItem: IFDRW_Job_Queue_Entry_List) {
        var  usedLink = dataItem.NavClientLink || dataItem["WindowsClientLink"]; // WindowsClientLink: for backward compatibility only
        fn.wOpenExtLink(usedLink);
    }

    ExecuteMethod(dataItem: IFDRW_Job_Queue_Entry_List, method, url) {
        const items = this.Data[url].Data,
            entry = <NavPageItem<IFDRW_Job_Queue_Entry_List>><any>items.GetItems(dataItem.Key)[0];

        // Mark "Execution" Item
        items.Current = entry;
        // Methods must be called in correct Company Context!
        var backUrl = items.ClientInfo.Url;
        items.ClientInfo.Url = BuildNavUrl(backUrl, entry.Model.Company);
        this.$c.finally(entry.Anchor.ExecuteMethod({ MethodName: method, Parameters: { workflowJobQueueEntry: entry.Key } }).then(fn.noop, err => {
            this.DialogService.ShowError(err);
        }), () => items.ClientInfo.Url = backUrl);
    }
    public Urls: INavUrlInfoEx[];

    public BaseUrls: string[];

    public CurrRefresh: PromiseLike<any>;

    public RefreshAction: IInfOperation = {
        Execute: () => {
            this.RefreshAction.Enabled = false;
            if (!this.CurrRefresh) {
                const afterRefresh = () => {
                    this.refreshInfo();
                    this.CurrRefresh = undefined;
                    this.RefreshAction.Enabled = true;
                };
                this.CurrRefresh = UISafe(this.$c.all(fn.DictToArray(this.Data).map(item => item.Refresh())).then(afterRefresh, afterRefresh));
            }
            return this.CurrRefresh;
        },
        Enabled: false,
    };
    private refreshInfo() {
        var allItems = fn.FlattenArray(fn.DictToArray(this.Data).map(item => item.Data.Items.map(x => x.Model)));
        var perStatus = fn.GroupBy(allItems, item => "" + item.Status);
        var errors = perStatus["" + Status.Error] || [];
        var terminatedCount = allItems.filter(item => item.Scheduled == false).length;
        var terminatedStr = terminatedCount > 0 ? terminatedCount + " Posten nicht aktiv" : "";
        var errorStr = errors.length ? (errors.length + ` fehlerhafte${errors.length == 1 ? "r" : ""} Posten`) : "";
        if (!(errorStr || terminatedStr))
            this.Info = "Keine Fehler";
        else
            this.Info = errorStr && terminatedStr ? errorStr + ", " + terminatedStr : errorStr + terminatedStr;
    }
    public readonly Data: {
        [url: string]: {
            Data: NavPageItems<IFDRW_Job_Queue_Entry_List>,
            GridOptions: INavItemsGridOptions,
            Refresh: () => PromiseLike<any>;
        }
    } = {};

    public Info: string = "...";

}
